"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/DisabledReason.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Tooltip = require('web/components/Tooltip');








/* P2': explains a disabled control on hover. The wrapper takes the hover: a
 * disabled button gets no mouse events, so its pointer events go to the
 * wrapper (see _recipients.scss). */
const DisabledReason = ({ reason, className, children }) => {
  if (!reason) return _react2.default.createElement(_react2.default.Fragment, null,  children )
  return (
    _react2.default.createElement(_Tooltip.HoverTooltip, {
      place: "bottom",
      type: "dark",
      className: _classBuilder2.default.call(void 0, 'broadcast-disabled-reason--container', className),
      content: _react2.default.createElement('span', { className: "broadcast-disabled-reason--tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}},  reason ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}

      , _react2.default.createElement('span', { className: "broadcast-disabled-reason", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  children )
    )
  )
}

exports. default = DisabledReason
